export { AuthGuard } from './auth.guard';



// WEBPACK FOOTER //
// ./src/app/shared/guards/index.ts